import React from 'react';
import PropTypes from 'prop-types';
import { Text, Flex, Box } from '@qga/roo-ui/components';
import GoogleMapStaticImage from 'components/maps/GoogleMapStaticImage';
import MapWithMarkerButton from 'components/PropertyPage/MapWithMarkerButton';
import formatPropertyAddress from 'components/formatters/FormatPropertyAddress';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { getBrowser } from 'store/userEnvironment/userEnvironmentSelectors';
import { isLegacyBrowser } from 'lib/browser/isLegacyBrowser';

const ViewMapText = styled(Text)`
  flex-basis: 40%;
`;

const PropertyMapStatic = ({ latitude, longitude, locationName, width, height, address }) => {
  const browser = useSelector(getBrowser);
  const enableMapOverlay = !isLegacyBrowser(browser?.name);

  const location = `${latitude},${longitude}`;
  const propertyAddress = formatPropertyAddress({
    streetAddressLines: address.streetAddress,
    suburb: address.suburb,
    state: address.state,
    country: address.country,
  });

  const Wrapper = enableMapOverlay ? MapWithMarkerButton : Box;

  return (
    <Wrapper latitude={latitude} longitude={longitude} locationName={locationName}>
      <GoogleMapStaticImage location={location} locationName={locationName} width={width} height={height} markers />
      <Flex>
        <Text fontSize={['sm', 'base']} color="greys.steel" textAlign="left">
          {propertyAddress}
        </Text>
        {enableMapOverlay && (
          <ViewMapText textStyle="link" fontSize={['sm', 'base']} textAlign="right">
            View map
          </ViewMapText>
        )}
      </Flex>
    </Wrapper>
  );
};

PropertyMapStatic.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  locationName: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  address: PropTypes.shape({
    streetAddress: PropTypes.array,
    suburb: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
  }).isRequired,
};

PropertyMapStatic.defaultProps = {
  width: 400,
  height: 216,
};

export default PropertyMapStatic;
